import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { IoMdArrowRoundBack } from 'react-icons/io';

import { Colors, Spacing } from '_styles';
import { LoadingContainer } from '_atoms';

import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  getSupportDesk,
  selectSupportDesk,
  selectSupportDeskStatus,
  updateSupportDesk,
} from '_redux/slices/messaging/messaging';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';

const ChatSettings = (props) => {
  const dispatch = useDispatch();
  const supportDesk = useSelector(selectSupportDesk);
  const supportDeskStatus = useSelector(selectSupportDeskStatus);
  const dbUser = useSelector(selectFirebaseInfo);

  const [status, setStatus] = useState('online');
  const [introductionMessage, setIntroductionMessage] = useState('');
  const [assistanceLink, setAssistanceLink] = useState('');

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  useEffect(() => {
    if (dbUser && dbUser.details && dbUser.details.authority) {
      dispatch(getSupportDesk(dbUser.details.authority));
    }
  }, [dbUser]);

  useEffect(() => {
    if (supportDesk && supportDesk.status) {
      setStatus(supportDesk.status);
    }
    if (supportDesk && supportDesk.introductionMessage) {
      setIntroductionMessage(supportDesk.introductionMessage);
    }
    if (supportDesk && supportDesk.assistanceLink) {
      setAssistanceLink(supportDesk.assistanceLink);
    }
  }, [supportDesk]);



  const handleUpdate = () => {
    let newSupportDesk = { ...supportDesk, status: status, introductionMessage: introductionMessage, assistanceLink: assistanceLink }
    dispatch(updateSupportDesk(newSupportDesk));
  }

  const goBack = () => { props.goBack() }

  return (
    <Col className='mt-5'>
      <LoadingContainer loading={supportDeskStatus == 'loading'} marginTop={-150}>

        <Row>

          {/* Back button */}
          <div style={{ justifyContent: 'flex-start' }}>
            <IoMdArrowRoundBack color={Colors.PRM_LIGHT_BLUE} size={28} onClick={goBack} style={{ alignSelf: 'flex-start', cursor: 'pointer' }} />
          </div>

          {/* Title */}
          <p className='mt-3' style={{ fontSize: 22, fontWeight: 'bold', color: Colors.TEXT_COLOR }}>{'Support Desk Settings'}</p>

        </Row>

        <Row>

          {/* Support Desk Status */}
          <div className='mt-3'>
            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Support Desk Status'}</Form.Label>
            <p style={{ opacty: 0.6 }}>Activate your support desk and allow passengers to send you messages. If you disable your support desk users on the PRM Assist app will not be able to send you messages.</p>

            <div className='mt-3' style={{ display: 'flex' }}>
              <Form.Check
                type="radio"
                label="Online"
                value="online"
                checked={status === 'online'}
                onChange={handleStatusChange}
              />

              <Form.Check
                type="radio"
                label="Offline"
                value="offline"
                checked={status === 'offline'}
                onChange={handleStatusChange}
                style={{ marginLeft: Spacing.SCALE_32 }}
              />
            </div>
          </div>
        </Row>



        <Row className='mt-3'>
          <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Introduction Message'}</Form.Label>
          <p style={{ opacty: 0.6 }}>This is the initial message displayed to users on the app who open support desk for the first time. It is recommended to give a general intro and to also include important information.</p>

          <Container>
            <Form.Control
              onChange={(e) => setIntroductionMessage(e.target.value)}
              type="textarea"
              placeholder="Type your introduction..."
              style={{ fontSize: 18 }}
              value={introductionMessage}
              numberOfLines={5}
            />
          </Container>
        </Row>

        <Row className='mt-3'>
          <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Assistance Link'}</Form.Label>
          <p style={{ opacty: 0.6 }}>To prevent passengers asking the same questions it is a good idea to include a FAQ link for your airport's PRM Assistance Information. If provided, we encourage users to consult the web page before creating a support ticket.</p>

          <Container>
            <Form.Control
              onChange={(e) => setAssistanceLink(e.target.value)}
              type="link"
              placeholder="Add your FAQ url..."
              style={{ fontSize: 18 }}
              value={assistanceLink}
              numberOfLines={5}
            />
          </Container>
        </Row>

        <Row className='mt-5'>
          <Container>
            <Button variant="primary" style={{ width: 300 }} onClick={handleUpdate}>
              Update
            </Button>
          </Container>
        </Row>
      </LoadingContainer>
    </Col>
  );
};

export default ChatSettings;
